<template>
  <div class="quiz container">
    <div class="top">
      <div class="back_box">
        <!-- <img src="@/assets/images/icons/icon_back.png" alt="" /> -->
        <el-button
          class="back-btn"
          type="text"
          icon="el-icon-arrow-left"
          @click="$router.go(-1)"
          >返回</el-button
        >
      </div>
      <div class="info">
        <img class="icon" src="@/assets/images/icons/a_test.png" alt="" />
        <div class="mid">
          <p class="title">{{ info.name }}</p>
          <p style="margin-top: 5px">
            <span class="time">{{
              formatDate(info.startTime, "MM-DD HH:mm")
            }}</span>
            <span class="shu">|</span>
            <span class="surplus" v-if="info.status == 'STARTED'"
              >剩余<i class="el-icon-time"></i>{{ surplus }}</span
            >
            <span class="end_tag" v-else>已结束</span>
          </p>
        </div>
      </div>
    </div>
    <div class="main">
      <div
        class="one"
        v-for="(item, idx) in info.questionList"
        :key="item.questionId"
      >
        <component
          :is="item.type"
          :question="item"
          :idx="idx + 1"
          :alreadyDo="info.alreadyDo"
        />
      </div>

      <el-button class="s-btn" v-show="!info.alreadyDo" type="primary" @click="handleSubmit"
        >提交</el-button
      >
    </div>
  </div>
</template>

<script>
import RADIO from "./components/radio";
import CHECKBOX from "./components/checkbox";
import BOOLEAN from "./components/boolean";
import SUPPLY from "./components/supply";
import ANSWER from "./components/answer";
import { formatDate, dateCount } from "@/utils/index";
import { quizInfo, submitQuiz } from "@/api/activity/quiz";
import { activityInfo } from "@/api/activity";
export default {
  components: {
    RADIO,
    CHECKBOX,
    BOOLEAN,
    SUPPLY,
    ANSWER,
  },
  data() {
    return {
      formatDate,
      info: {},
      surplus: "",
    };
  },
  created() {
    this.getInfo();
  },
  beforeDestroy() {
    clearInterval(this.timerId);
  },
  methods: {
    // 活动信息
    getInfo() {
      let activityId = this.$route.query.activityId;
      activityInfo(activityId).then((res) => {
        if (res.code == 0) {
          this.info = res.data;
          let end = new Date(this.info.startTime).getTime();
          let duration = this.info.duration * 60 * 1000;
          end = end + duration;
          let nowTime = +new Date();
          let times = (end - nowTime) / 1000;
          if (times > 0) {
            this.surplus = dateCount(times);
            this.timerId && clearInterval(this.timerId);
            this.timerId = setInterval(() => {
              if (times <= 0 && this.timerId) {
                clearInterval(this.timerId);
                this.getInfo();
              }
              this.surplus = dateCount(times);
              times--;
            }, 1000);
          }
        } else {
          console.log(res.msg);
        }
      });

      quizInfo({ activityId }).then((res) => {
        if (res.code == 0) {
          this.info.alreadyDo = res.data.complete;
          this.info.questionList = res.data.questionList;
        } else {
          console.log(res.msg);
        }
      });
    },
    handleSubmit() {
      let answers = [];
      this.info.questionList.forEach((item) => {
        let answerObj = {
          answer: [],
          questionId: null,
        };
        answerObj.questionId = item.questionId;
        answerObj.answer = item.myAnswerList;
        if (item.type == "SUPPLY") {
          let arr = [];
          item.myAnswerList.forEach((s) => {
            arr.push(Object.values(s)[0]);
          });
          answerObj.answer = arr;
        }
        answers.push(answerObj);
      });
      let activityId = this.$route.query.activityId;
      this.$confirm(`确定要提交吗？`)
        .then(() => {
          this.$loading.show();
          submitQuiz({ activityId, answers }).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("提交成功");
              this.getInfo();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.quiz {
  height: 100%;
  .top {
    margin-top: 30px;
    margin-bottom: 20px;
    width: 100%;
    text-align: left;
    .back_box {
      display: inline-block;
      width: calc(100% - 1126px);
      text-align: center;
      vertical-align: middle;
      cursor: pointer;
      img {
        width: 44px;
      }
      p {
        color: #969696;
        font-size: 16px;
      }
    }
    .info {
      position: relative;
      display: inline-block;
      padding: 24px 30px;
      background-color: #fff;
      width: 1126px;
      vertical-align: middle;
      .icon {
        width: 44px;
        height: 44px;
      }
      .mid {
        display: inline-block;
        margin-left: 20px;
        vertical-align: middle;
      }

      .title {
        font-size: 16px;
        color: #333;
      }
      .time {
        margin-top: 5px;
        color: #999;
        font-size: 14px;
      }

      .shu {
        padding: 0 10px;
        color: #ddd;
      }
      .el-icon-time {
        margin: 0 5px;
      }
      .surplus {
        color: sandybrown;
      }
      .end_tag {
        color: #c8c8c8;
      }
    }
  }
  .main {
    padding: 0 30px 30px;
    height: calc(100% - 30px - 20px - 88px - 30px);
    background-color: #fff;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 4px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }
    .one {
      text-align: left;
    }
    .s-btn {
      margin-top: 30px;
    }
  }
}
</style>